import { isMobile } from "react-device-detect";

import authenticationService from "../authentication";
import { getTranslation } from "../../utils/helper";

export default class Metamask {
  static isMetamaskAvailable(ethereum) {
    if (!ethereum) {
      setTimeout(() => {
        window.open("https://metamask.io/");
      }, 2000);
      return false;
    }
    return true;
  }

  static async signMessage(message, nonce, account) {
    const { ethereum } = window;
    const params = [message, account, nonce];
    return ethereum.request({
      method: "personal_sign",
      params
    });
  }

  static async connectMetamaskMobile() {
    const metamaskAppDeepLink =
      "https://metamask.app.link/dapp/www.superbet-demo.tk";
    window.open(metamaskAppDeepLink);
  }

  static async requestAccount(payload) {
    const { ethereum } = window;
    if (this.isMetamaskAvailable(ethereum)) {
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts"
        });
        if (accounts?.length > 0) {
          let nonce = null;
          let userId = null;
          const nonceData = await authenticationService.getMetamaskUser({
            publicAddress: accounts[0]
          });
          if (nonceData?.data?.nonce) {
            nonce = nonceData.data.nonce;
          }
          if (nonceData?.data?.userId) {
            userId = nonceData.data.userId;
          }
          if (nonceData?.error) {
            throw new Error(nonceData.error.message);
          }
          const message = `I am signing my one-time nonce: ${nonce}`;
          const signature = await this.signMessage(message, nonce, accounts[0]);
          const sendVerifyData = {
            publicAddress: accounts[0],
            signature,
            referralCode: payload
          };
          if (userId) {
            sendVerifyData.userId = userId;
          }
          const verifySigData =
            await authenticationService.verifyMetamaskSignature(sendVerifyData);
          if (verifySigData?.error) {
            throw Error(verifySigData?.error?.message);
          }
          verifySigData.data.walletAddress = accounts[0];
          return { data: verifySigData.data };
        }
      } catch (error) {
        return {
          error
        };
      }
    } else {
      if (isMobile) {
        this.connectMetamaskMobile();
        return { data: "REDIRECTED_TO_MOBILE_APP" };
      }
      return {
        error: Error(getTranslation("HOME.INSTALL_METAMASK_MSG"))
      };
    }
  }

  static async connectToMetamask(userId) {
    const { ethereum } = window;
    if (this.isMetamaskAvailable(ethereum)) {
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts"
        });
        if (accounts?.length > 0) {
          let nonce = null;
          const nonceData = await authenticationService.getMetamaskUser({
            publicAddress: accounts[0],
            userId
          });
          if (nonceData?.data?.nonce) {
            nonce = nonceData?.data?.nonce;
          }
          if (nonceData?.error) {
            throw new Error(nonceData.error.message);
          }
          const message = `I am signing my one-time nonce: ${nonce}`;
          const signature = await this.signMessage(message, nonce, accounts[0]);
          const { data, error } =
            await authenticationService.verifyMetamaskSignature({
              publicAddress: accounts[0],
              signature,
              userId
            });
          if (data) {
            data.walletAddress = accounts[0];
            return { data };
          }
          if (error) {
            return { error };
          }
        }
      } catch (error) {
        return {
          error
        };
      }
    } else {
      if (isMobile) {
        this.connectMetamaskMobile();
        return { data: "REDIRECTED_TO_MOBILE_APP" };
      }
      return {
        error: Error(getTranslation("HOME.INSTALL_METAMASK_MSG"))
      };
    }
  }
}
